import React, { useContext } from 'react'
import propTypes from 'prop-types'
import { withStyles } from '@material-ui/core'
import MuiAccordion from '@material-ui/core/Accordion'
import MuiAccordionSummary from '@material-ui/core/AccordionSummary'
import MuiAccordionDetails from '@material-ui/core/AccordionDetails'

import { appColors } from '../../globalStyles'
import { ApplicationContext } from '../../contexts/ApplicationContext'

const ThemedAccordion = withStyles({
  root: {
    border: 'none',
    boxShadow: 'none',
  }
})(MuiAccordion)

const AccordionSummary = withStyles({
  root: {
    border: 'none',
    borderBottom: `1px solid ${appColors.card_line_color}`,
    color: ({ theme }) => theme.primaryColor,
    '&:hover': {
      backgroundColor: appColors.system_background
    }
  }
})(MuiAccordionSummary)

export const Accordion = ({ summary, details, setExpanded }) => {
  const onChange = (_event, expanded) => setExpanded(expanded)
  const { theme } = useContext(ApplicationContext)
  return (
    <ThemedAccordion TransitionProps={{ unmountOnExit: true }} square onChange={onChange}>
      <AccordionSummary theme={theme}>
        {summary}
      </AccordionSummary>
      <MuiAccordionDetails>
        {details}
      </MuiAccordionDetails>
    </ThemedAccordion>
  )
}

Accordion.propTypes = {
  summary: propTypes.node.isRequired,
  details: propTypes.node.isRequired,
  setExpanded: propTypes.func
}
